(function () {
  document.querySelectorAll('.ct-pdp').forEach(function (root) {
    // Gallery click-to-swap
    var mainImg = root.querySelector('[id^="ct-main-image-"]');
    root.querySelectorAll('.ct-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full && mainImg) mainImg.src = full;
        root.querySelectorAll('.ct-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    // Product details "Show More" toggle
    root.querySelectorAll('.ct-show-more').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.previousElementSibling;
        var expanded = body.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Show Less' : 'Show More';
      });
    });

    // Scroll-pinned filtration diagram: activate callout whose marker is in view
    var pinSection = root.querySelector('.ct-pin-section');
    if (pinSection) {
      var markers = pinSection.querySelectorAll('.ct-pin-marker');
      var callouts = pinSection.querySelectorAll('.ct-pin-callout');
      if ('IntersectionObserver' in window && markers.length) {
        var pinObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = entry.target.getAttribute('data-pin-marker');
              callouts.forEach(function (c) {
                c.classList.toggle('is-active', c.getAttribute('data-pin-index') === idx);
              });
            }
          });
        }, { threshold: 0.5, rootMargin: '-40% 0px -40% 0px' });
        markers.forEach(function (m) { pinObserver.observe(m); });
      }
    }

    // Reviews carousel: one card visible at a time, prev/next arrows
    var reviewsCarousel = root.querySelector('.ct-reviews__carousel');
    if (reviewsCarousel) {
      var reviewCards = reviewsCarousel.querySelectorAll('.ct-review-card');
      var reviewIdx = 0;
      function showReview(i) {
        reviewCards.forEach(function (c, ci) { c.classList.toggle('is-active', ci === i); });
      }
      var prevBtn = reviewsCarousel.querySelector('.ct-reviews__arrow--prev');
      var nextBtn = reviewsCarousel.querySelector('.ct-reviews__arrow--next');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          reviewIdx = (reviewIdx - 1 + reviewCards.length) % reviewCards.length;
          showReview(reviewIdx);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          reviewIdx = (reviewIdx + 1) % reviewCards.length;
          showReview(reviewIdx);
        });
      }
    }

    // "Also bought with": real recommendations from Shopify's built-in endpoint (no placeholder products)
    var alsoBought = root.querySelector('.ct-also-bought');
    if (alsoBought) {
      var pid = alsoBought.getAttribute('data-product-id');
      var track = alsoBought.querySelector('.ct-also-bought__track');
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=4&intent=related')
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (data) {
          if (!data.products || !data.products.length) { alsoBought.style.display = 'none'; return; }
          data.products.forEach(function (p) {
            var card = document.createElement('a');
            card.href = p.url;
            card.className = 'ct-also-bought__card';
            var img = (p.featured_image && p.featured_image.url) || p.featured_image || '';
            var price = typeof p.price === 'number' ? '$' + (p.price / 100).toFixed(2) : '';
            card.innerHTML =
              '<img src="' + img + '" alt="" loading="lazy">' +
              '<span class="ct-also-bought__title">' + (p.title || '') + '</span>' +
              (price ? '<span class="ct-also-bought__price">' + price + '</span>' : '');
            track.appendChild(card);
          });
        })
        .catch(function () { alsoBought.style.display = 'none'; });
    }

    // Sticky add-to-cart bar: show once the main buy button scrolls out of view
    var addBtn = root.querySelector('.ct-add-btn:not(.ct-add-btn--sticky)');
    var stickyBar = root.querySelector('[id^="ct-sticky-bar-"]');
    if (addBtn && stickyBar && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(addBtn);
    }
  });
})();
